import Http from '@/Http/Request';
import { useMutation } from 'react-query';
import { UpdateModulePayload } from './types';

const updateModule = async (payload: UpdateModulePayload) => {
	const { data } = await Http({
		method: 'POST',
		url: 'updateModuleApi',
		data: payload,
	});
	return data;
};

const useUpdateModule = () => {
	const { mutate } = useMutation<UpdateModulePayload, Error, UpdateModulePayload>({
		mutationKey: ['updateModule'],
		mutationFn: (payload: UpdateModulePayload) => updateModule(payload)
		
	})


	return { mutate }

};

export default useUpdateModule;
